const formatAs = {
  price: (price, currencyISO = 'GBP') => {
    if (price === undefined || price === null) {
      return ''
    }
    if (price < 0) {
      return formatAs.price(0, currencyISO)
    }
    if (Number.isInteger(price)) {
      // Older versions of iOS can throw a RangeError when displaying maximumFractionDigits so we need to try/catch this
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyISO,
          currencyDisplay: 'narrowSymbol',
          maximumFractionDigits: 0
        }).format(price)
      } catch (error) {
        if (error instanceof RangeError) {
          console.error(error)
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currencyISO,
            currencyDisplay: 'narrowSymbol'
          }).format(price)
        }
        throw error
      }
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyISO,
      currencyDisplay: 'narrowSymbol'
    }).format(price)
  },
  priceShowFree: (price, currencyISO = 'GBP') => {
    if (price === undefined || price === null) return ''
    if (price <= 0) return 'Free'
    return formatAs.price(price, currencyISO)
  },
  title: (str) => {
    if (!str) return ''
    return str.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
  }
}

export default formatAs
